import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { CancelButton } from "../Controls/CancelButton";
import Checkbox from "../Controls/Checkbox";
import { ConfirmButton } from "../Controls/ConfirmButton";
import QueueStyle from "../Styled/Queue.style";
import StackStyle from "../Styled/Stack.style";

export default function DisplayOnWebsiteWarning({
  open,
  onClose,
  onConfirm,
  displayOnWebsite,
  setDisplayOnWebsite,
  imagesInput,
}) {
  return (
    <Dialog open={open} onClose={onClose} sx={{ padding: "10px 25px" }}>
      <DialogTitle>
        <h5>Warning</h5>
      </DialogTitle>
      <DialogContent>
        <StackStyle alignContent="start" gap="10px">
          <p>
            Display on website has been checked but there are no images
            uploaded.
          </p>
          <p>
            Either upload image(s) or uncheck display on website to proceed.
          </p>
          <QueueStyle>
            <Checkbox
              label="Display on website"
              checked={displayOnWebsite}
              onChange={setDisplayOnWebsite}
            />
            {imagesInput}
          </QueueStyle>
          <QueueStyle justifyContent="center">
            <CancelButton onClick={onClose} />
            <ConfirmButton onClick={onConfirm} />
          </QueueStyle>
        </StackStyle>
      </DialogContent>
    </Dialog>
  );
}
